import { render, staticRenderFns } from "./questionInfo.vue?vue&type=template&id=ef93eb5a&scoped=true"
import script from "./questionInfo.vue?vue&type=script&lang=js"
export * from "./questionInfo.vue?vue&type=script&lang=js"
import style0 from "./questionInfo.vue?vue&type=style&index=0&id=ef93eb5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef93eb5a",
  null
  
)

export default component.exports